// extracted by mini-css-extract-plugin
export default {"disclaimer":"k_bm"};